// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import * as CSS from 'csstype';

export type ContextType = {
  parentState: any;
  updateParent: (data: any, cb?: (() => void)) => void;
}

export const FilterContext: React.Context<ContextType> = React.createContext<ContextType>({ parentState: {}, updateParent: () => { /* pass */ } });
